
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
  --layout-gap:var(--sic-home-hero--layout-gap, var(--grid-gap));
  --sic-body-text--font-size:var(--sic-home-hero--default--subtitle-font-size);
  --sic-body-text--line-height:var(
    --sic-home-hero--default--subtitle-line-height
  );
}
.layout-container{
  display:grid;
  gap:var(--layout-gap);
  grid-template-columns:repeat(12, [col-start] 1fr);
  align-items:center;
}
.layout-container.layout-is-mobile{
    display:flex;
    flex-direction:column;
  }
.content{
  grid-column:col-start / span 4;
}
.subtitle{
  padding-block-start:var(--spacing-04);
}
.cta-grid{
  --sic-cta--default--font-size:var(--body-01-font-size);
  --sic-body-text--font-size:var(--fs-base);
  grid-column:col-start 6 / span 7;
}
`;